import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import { Container, Image, Title, Text } from './styles';

const Props = {
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
};

const DefaultProps = {
  title: '',
  text: '',
  buttonText: '',
  onButtonClick: () => {},
  imageSrc: '',
  imageAlt: '',
};

export default function SearchEmptyState({
  title,
  text,
  buttonText,
  onButtonClick,
  imageSrc,
  imageAlt,
}) {
  return (
    <Container>
      <Image src={imageSrc} alt={imageAlt} />
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Button isInline variant="secondary" onClick={onButtonClick}>
        {buttonText}
      </Button>
    </Container>
  );
}

SearchEmptyState.propTypes = Props;
SearchEmptyState.defaultProps = DefaultProps;
